// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vhq9","index":"styles_index__1jI-D"};